// Resolve the runtime asset base path for lazy chunks — assigned to `__webpack_public_path__`
// (webpack/Rspack's runtime public path) by the client entry before any other module loads.
//
// Derived from the entry `<script>`'s own URL, which the server writes per-environment
// (`…/static/main.<hash>.js`) and which is guaranteed present in the DOM by the time the entry runs.
// Race-proof: React 19 hoists the `@loadable` entry into <head> and runs it `async`, so it can execute
// before the rest of <body> is parsed — any approach that reads a body-tail global (or
// `document.currentScript`, null for async scripts) can be out-raced, poisoning every lazy-chunk URL to
// `<origin>/undefined<chunk>.js` (NOA-3244). Falls back to the same-origin `/static/` mount the server
// always serves if the entry tag can't be found.
export const resolvePublicPath = (doc: Document = document): string => {
  // `new URL('.', src)` resolves to the script's directory — the base prepended to lazy-chunk names.
  const entry = doc.querySelector<HTMLScriptElement>('script[src*="/main."]');
  return entry?.src ? new URL('.', entry.src).href : '/static/';
};
